import { DatePipe } from '@angular/common';
import { HttpEvent, HttpEventType, HttpResponse } from '@angular/common/http';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import * as _ from 'lodash';
import { WebcamImage } from 'ngx-webcam';
import { ENavigationRoute } from 'src/app/models/enum/navigation-route';
import { ENavigationErrorType } from 'src/app/models/navigation-error-type';
import { SimpleListModel } from 'src/app/models/simple-list-model';
import { DocumentService } from 'src/app/services/document.service';
import { PictureService } from 'src/app/services/picture.service';
import { CoreData } from 'src/app/tools/core-data';
import { LoadingTask } from 'src/app/tools/loading-task';
import { NotificationManager } from 'src/app/tools/notification-manager';
import { EDocumentType } from 'src/app/tools/ui/mutilple-file-upload-box/document-type';
import { StringConverter } from 'src/app/tools/ui/string-converter';
import { db } from '../../db/db';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
    selector: 'app-add-photo',
    templateUrl: './add-photo.component.html',
    styleUrls: ['./add-photo.component.scss']
})
export class AddPhotoComponent implements OnInit, OnDestroy {
    webcamImage: WebcamImage | undefined;

    private alreadyPicked: number[] = [];
    EDocumentType = EDocumentType; // Aliasing of enum available in html
    public DocumentTypeList: SimpleListModel[] =
        Object.values(EDocumentType)
            .filter(x => !isNaN(Number(x)) && (Number(x) >= 1 && Number(x) <= 6 || Number(x) === 13))
            .map(x => {
                const slm = new SimpleListModel();
                slm.idx = x as number;
                slm.s = StringConverter.getDocumentTypeName(x as EDocumentType);
                return slm;
            });

    // application data
    interventionCode: string;
    interventionType: string;
    DocumentType: EDocumentType;
    Description: string = '';
    Capture: string;

    constructor(

        private pictureService: PictureService,
        public coreData: CoreData,
        private router: Router,
        private route: ActivatedRoute,
        private snackBar: MatSnackBar,
        public loadingTask: LoadingTask,
        private documentService: DocumentService,
        public datepipe: DatePipe) {

    }
    ngOnDestroy(): void {

    }

    async ngOnInit() {

        if (!this.route.snapshot.params['interventionCode'] || !this.route.snapshot.params['type']) {
            this.router.navigate([ENavigationRoute.Error, { type: ENavigationErrorType.URL }]);
            return;
        }
        // screen functional data loading
        this.interventionCode = this.route.snapshot.params['interventionCode'];
        this.interventionType = this.route.snapshot.params['type'];
        // if (this.route.snapshot.params['alreadyPicked'] !== undefined) {

        // this.route.snapshot.params['alreadyPicked'].split(',').map(x => parseInt(x, 10));
        this.alreadyPicked = await (await db.getInterventionByCode(this.interventionCode)).Documents?.map(d => d.DocumentType);
        if (this.alreadyPicked)
            _.remove(this.DocumentTypeList, x => this.alreadyPicked.includes(x.idx));
        // }

        this.pictureService.ImageEmitter.subscribe(img => {
            this.Capture = img;

            if (img) {
                this.DocumentType = this.pictureService.getImageInfo().t;
                this.Description = this.pictureService.getImageInfo().d;
            }
        });
        // db.getPictureList(await db.getInterventionByCode(this.interventionCode));
    }

    async changed(event) {
        console.log(event);

        const files = event.srcElement.files as File[];

        const toBase64 = file => new Promise<any>((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = error => reject(error);
        });

        const result = await toBase64(files[0]);
        this.Capture = result;
    }

    canSave() {
        return !this.loadingTask.IsLoading && this.DocumentType && this.Capture && this.Capture !== 'null';
    }

    getMaxHeight() {
        return window.innerHeight - 250;
    }

    // openPhotoView() {
    //     // Just save document information before quiting the view to be able to reapply those values when comebacking in this page
    //     this.pictureService.updateImageInfo(this.DocumentType ?? null, this.Description ?? null);
    //     this.router.navigate([ENavigationRoute.PhotoViewer, { interventionCode: this.interventionCode, alreadyPicked: this.alreadyPicked.map(x => x) }], { replaceUrl: true });
    // }

    getThumbnailsSize() {
        return window.innerWidth - 30;
    }

    goToPictureTaking() {
        this.pictureService.updateImageInfo(this.DocumentType ?? null, this.Description ?? null);
        this.router.navigate([ENavigationRoute.PhotoViewer, { interventionCode: this.interventionCode, type: this.interventionType }]);
        // alreadyPicked: this.alreadyPicked.map(x => x)
    }
    // goBack() {
    //   this.pictureService.clearInfo();
    //   this.router.navigate([ENavigationRoute.InterventionDashboard, { code: this.interventionCode }]);
    // }

    async savePhoto() {

        if (this.coreData.IsOffline) {
            if (this.DocumentType) {

                await db.attachPictureToIntervention(
                    await db.getInterventionByCode(this.interventionCode),
                    db.mapDocumentToPictureEntity(
                        this.DocumentType,
                        this.Description,
                        this.Capture,
                        `${this.datepipe.transform(Date.now(), 'dd-MM-yyyy')}[${this.interventionCode}][DT-${this.DocumentType}].jpg`));

                // this.router.navigate([ENavigationRoute.InterventionDashboard, { code: this.interventionCode, type: this.interventionType }]);
                //   await db.attachPictureToIntervention(mop, newRId);
                //

                //   this.pictureDbService.savePicture(this.pictureDbService.generatePictureKey(this.interventionCode, this.DocumentType), this.Capture).subscribe(x => {

                //     this.coreData.setOfflineInterventionPictureList(this.interventionCode, this.DocumentType);
                //     if (this.DocumentType === EDocumentType.OtherPicture) {
                //       this.coreData.setOtherPictureDescription(this.interventionCode, this.Description);
                //     }
                NotificationManager.handleSuccess('Photo correctement ajoutée', this.snackBar);
                _.remove(this.DocumentTypeList, dt => dt.idx === this.DocumentType);
                this.alreadyPicked.push(this.DocumentType);
                //     this.pictureService.updateImage(null);
                this.DocumentType = null;
                this.Description = null;
                this.Capture = null;
                //     // 
                //   });
                this.pictureService.clearInfo();
            } else {
                NotificationManager.handleWarning('Veuillez choisir un type de photo', this.snackBar);
            }
        } else {
            this.documentService
                .createDocument(
                    this.interventionCode,
                    this.DocumentType,
                    this.dataURLtoFile(this.Capture, `${this.datepipe.transform(Date.now(), 'dd-MM-yyyy')}[${this.interventionCode}][DT-${this.DocumentType}].jpg`))
                .subscribe(
                    (event: HttpEvent<any>): void => {
                        if (event.type === HttpEventType.UploadProgress) {
                            // @TODO Put the spinner with percentage ?
                            // NotificationManager.handleSuccess(`${event.loaded / event.total}`, this.snackBar);
                            // this.PercentDone = Math.round(80 * event.loaded / event.total);
                            // if (this.PercentDone >= 80) {
                            //   this.Sub = interval(100).pipe().subscribe(() => {
                            //     if (this.PercentDone < 99) {

                            //       this.PercentDone = this.PercentDone + 1;
                            //     }
                            //   });
                            // }
                        } else if (event instanceof HttpResponse) {
                            NotificationManager.handleSuccess('Photo correctement ajoutée', this.snackBar);
                            _.remove(this.DocumentTypeList, x => x.idx === this.DocumentType);

                            // this.pictureService.updateImage(null);
                            this.DocumentType = null;
                            this.Description = null;
                            this.Capture = null;
                            this.pictureService.clearInfo();
                            // this.router.navigate([ENavigationRoute.InterventionDashboard, { code: this.interventionCode }]);
                            // this.Sub.unsubscribe();
                            // this.PercentDone = 100;
                            // setTimeout(() => {
                            //   this.PercentDone = 0;
                            //   this.dialogRef.close(event.body); // EDM ID
                            // }, 500);
                        }
                    },
                    (err) => {
                        // this.Sub.unsubscribe();
                        // this.dialogRef.close();
                        console.log('Upload Error:', err);
                    }, () => {
                    }
                );
        }
    }

    dataURLtoFile(dataurl, filename) {
        const arr = dataurl.split(',');
        const mime = arr[0].match(/:(.*?);/)[1];
        const bstr = atob(arr[1]);
        let n = bstr.length;
        const u8arr = new Uint8Array(n);

        while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
        }
        return new File([u8arr], filename, { type: mime });
    }

    // public goToNextWebcam() {
    //   // if (this.isLoading) {
    //   //   return;
    //   // }
    //   this.nextWebcam.next(true);
    // }

    // public get triggerObservable(): Observable<void> {
    //   return this.trigger.asObservable();
    // }

    // public handleImage(webcamImage: WebcamImage): void {
    //   this.webcamImage = webcamImage;
    // }

    // public get nextWebcamObservable(): Observable<boolean | string> {
    //   return this.nextWebcam.asObservable();
    // }

    // public cameraWasSwitched(deviceId: string): void {
    //   this.deviceId = deviceId;
    // }

    // public handleInitError(error: WebcamInitError): void {
    //     this.snackBar.open(error.message, 'OK', { duration: 3000 });
    // }
    handleImage(webcamImage: any) {
        this.webcamImage = webcamImage;
    }
}
